export function LinkedInIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      aria-hidden="true"
      className={className}
    >
      <rect x="0.5" y="0.5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1" fill="none" />
      <rect x="3.5" y="3.5" width="1.5" height="1.5" fill="currentColor" />
      <rect x="3.5" y="6" width="1.5" height="5.5" fill="currentColor" />
      <rect x="6.5" y="6" width="1.5" height="5.5" fill="currentColor" />
      <path
        d="M8 6.5c0 0 0.5-0.5 2-0.5s2 1 2 2v3.5h-1.5V8.5c0-0.5-0.2-1-1-1s-1 0.5-1 1v3h-0.5V6.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GitHubIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      aria-hidden="true"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0.5C3.63 0.5 0.5 3.63 0.5 7.5c0 3.07 1.99 5.68 4.74 6.6.35.06.48-.15.48-.34v-1.2c-1.93.42-2.34-.93-2.34-.93-.32-.8-.77-1.02-.77-1.02-.63-.43.05-.42.05-.42.7.05 1.06.72 1.06.72.62 1.06 1.62.75 2.02.57.06-.44.24-.75.44-.92-1.54-.17-3.16-.77-3.16-3.42 0-.75.27-1.37.72-1.85-.07-.18-.31-.88.07-1.83 0 0 .58-.19 1.91.71A6.6 6.6 0 0 1 7.5 3.9c.59 0 1.18.08 1.74.23 1.32-.9 1.9-.71 1.9-.71.38.95.14 1.65.07 1.83.45.48.72 1.1.72 1.85 0 2.66-1.62 3.24-3.17 3.41.25.22.47.64.47 1.29v1.92c0 .19.13.4.48.34A6.51 6.51 0 0 0 14.5 7.5C14.5 3.63 11.37.5 7.5.5z"
        fill="currentColor"
      />
    </svg>
  );
}
